import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Select.module.css";
/**
 * Select do Azim CRM.
 * Baseado em `<select>` nativo (acessibilidade/teclado/mobile de graça),
 * com o chrome nativo estilizado via tokens do design system.
 */
export function Select({ value, options, onChange, ariaLabel, id, disabled = false, className }) {
    return (_jsxs("div", { className: [styles.wrapper, disabled ? styles.disabled : "", className ?? ""].filter(Boolean).join(" "), children: [_jsx("select", { id: id, className: styles.select, value: value, disabled: disabled, ...(ariaLabel !== undefined ? { "aria-label": ariaLabel } : {}), onChange: (e) => onChange(e.target.value), children: options.map((opt) => (_jsx("option", { value: opt.value, children: opt.label }, opt.value))) }), _jsx(Icon, { name: "chevronDown", size: 14, className: styles.chevron ?? "" })] }));
}
//# sourceMappingURL=Select.js.map